import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const safeSelector = (rootState: RootState) => rootState.global;
export const globalReloadingSelectors = createSelector(safeSelector, (global) => global.reloading);
